import { getRailsClient } from "../client";
import { Assessment, Question, QuizSubmissionRequest, UserStatistics } from "./types/quizTypes";

interface QuizResponse {
  assessment: Assessment;
  userStatistics: UserStatistics;
  question: Question;
  nextLesson: any;
  noMoreAttempts: boolean;
}

export const getAssessment = async (lessonId: number): Promise<QuizResponse> => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/levels/undefined/lessons/${lessonId}/assessments`;
    const { data } = await client.get(API);
    return data;
  } catch (error) {
    console.error("Error getting assessment:", error);
    throw error;
  }
};

export const submitQuizQuestion = async ({
  slug,
  questionId,
}: {
  slug: string;
  questionId: string;
}) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/assessment_questions/${questionId}`;
    const { data } = await client.put(API, {
      assessmentQuestion: {
        slug: slug,
      },
    });
    return data;
  } catch (error) {
    console.error("Error submitting quiz question:", error);
    throw error;
  }
};

export const retakeQuiz = async (lessonId: number) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/v1/levels/undefined/lessons/${lessonId}/assessments`;
    const { data } = await client.post(API);
    return data;
  } catch (error) {
    console.error("Error restarting quiz:", error);
    throw error;
  }
};

export const getQuiz = async (lessonKey: string) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/atlas/v1/quiz/${lessonKey}`;
    const { data } = await client.get(API);
    return data;
  } catch (error) {
    console.error("Error loading quiz:", error);
    throw error;
  }
};

export const submitQuiz = async (lessonKey: string, quiz: QuizSubmissionRequest) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/atlas/v1/quiz/${lessonKey}/submit`;
    const { data } = await client.put(API, {
      assessment: quiz,
    });
    return data;
  } catch (error) {
    console.error(`Error submitting quiz for lessonKey ${lessonKey}:`, error);
    throw error;
  }
};

export const retryQuiz = async (lessonKey: string) => {
  try {
    const client = getRailsClient();
    const API = `/api/internal_api/atlas/v1/quiz/${lessonKey}`;
    const { data } = await client.post(API);
    return data;
  } catch (error) {
    console.error(`Error retrying quiz for lessonKey ${lessonKey}:`, error);
    throw error;
  }
};
